<section class="user-constiner">
  <header class="d-flex align-items-center p-2">
    <div>
      <button mat-icon-button (click)="close()" class="d-flex align-items-center gap-1">
        <mat-icon>close</mat-icon>
        <span class="font-weight-bold user-manual" style="font-size: 20px;
    cursor: none;">{{ 'ime.user.manual' | translate }}
        </span>
      </button>
      <div class="ml-3 d-flex align-items-center gap-3">
        <button mat-icon-button (click)="downloadUserManual()" class="d-flex align-items-center gap-1">
          <mat-icon class="text-primary" style="font-size: 20px;">download</mat-icon><span class="text-primary"
            style="cursor: pointer;">{{
            'download' | translate
            }}
          </span>
        </button>
        <span style="margin-left: 60px; font-size: x-small;">{{'ime.usermanual.main.title.content.label' |
          translate}}</span>

      </div>
    </div>

  </header>
  <mat-divider></mat-divider>

  <main class="d-flex flex-column overflow-auto h-100 w-100 pb-3">
    <div class="news-container">
      <div class="ml-2 mt-2 d-flex justify-content-between align-items-center">
        <h6 class="text-primary font-weight-bold layer ">{{'ime.user.manual.sub.title' | translate}}
          @if (loadPdfProgress !== 100) {
          <span>: {{loadPdfProgress}} %</span>
          }
        </h6>

      </div>
      @if (loadPdfProgress !== 100) {
      <div class="outer">
        <mat-progress-bar mode="determinate" [value]="loadPdfProgress"> loadPdfProgress % </mat-progress-bar>
      </div>
      }
      <div #pdfViewerContainer></div>
    </div>
  </main>
</section>